import "./PageNotFound.scss";
import { Link } from "react-router-dom";

function PageNotFound() {
  return (
    <>
      <div>
        <h1>Error 404 - Page Not Found</h1>
        <p>The page you are looking for doesn't exist or has been moved</p>
        <Link to="/">Back</Link>
      </div>
    </>
  );
}

export default PageNotFound;
